module.exports = __webpack_public_path__ + "static/media/tokens-16.87111638.svg";